import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import AppBar from '../../commons/AppBar'
import Ws from '../../providers/Ws';
import { TableHead, Table, TableBody, TableRow, TableCell, Grid, Divider } from '@material-ui/core';
import Utils from '../../providers/Utils';
import ColumnChart from '../../commons/ColumnChart'
import BarChart from '../../commons/BarChart'
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import ButtonsModules from '../../commons/ButtonsModules'
// import BarCharts3DFinanciar from '../chestionare/commons/charts/3dCharts/BarCharts3DFinanciar';
import ExplicatieIndicatori from '../../commons/dialogs/ExplicatieIndicatori';
import AnalizaDeVanzariSiClienti from './AnalizaDeVanzariSiClienti';
import FisaClientului from './FisaClientului';
import FacturiNeincasate from './FacturiNeincasate';
import ClientiNoiLunar from './ClientiNoiLunar';
import ComparatieRealizatPlanificat from './ComparatieRealizatPlanificat';
import TrendDePastrareClientiTrimestru from './TrendDePastrareClientiTrimestru';
import ClientiStari from './ClientiStari';
import SegmentareClientiInFunctieDeCaracteristici from './SegmentareClientiInFunctieDeCaracteristici';
import FromServer from './FromServer';
import { TopButtons } from '../../commons/TopButtons';
import SiteMap from '../../commons/SiteMap';
import BackToTop from '../../commons/BackToTop';

export default class ParametruBilant extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listChart: [],
            listTable: [{ val: [] }],
            listSold: null,
            listClassifExpl: [],
            isOpenExplanation: false,
            strCriteriul: '',
            mapButtons:[{id:'financiarcontabil', label:'Inapoi Financiar', color:'#900DCB'},
        
        ],
            buttonSelectat:'indicatori',//indicatori
            topButtons:[{id:'indicatori', label:'Indicatori', color:'#900DCB'},
                        {id:'evolutia_soldului', label:'Evolutia soldului pe client', color:'#097BED'},
                        {id:'fisa_clientului', label:'Fisa Clientului', color:'#C8C779'},
                        {id:'clienti_luna', label:'Clienti noi castigati lunar', color:'#59D862'},
                        {id:'facturi', label:'Facturi', color:'#3BCDFE'},
                        {id:'comparatie_realizat', label:'Comparatie Realizat Planificat', color:'#FF9A35'},
                        {id:'segmentare_clienti', label:'Segmentare Clienti', color:'#D0DD1C'},
                        {id:'clienti_stari', label:'Clienti Stari', color:'rgb(222, 11, 14)'},
                    ]

        }
    }
    componentDidMount() {
        this.testFunc()
    }




    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

    testFunc = async () => {
        let fs = new FromServer();


        let getData = await fs.getProfilogramaAndSolduriFurnizoriClienti(this.props.match.params.idhead)

        // console.warn('getData :', getData.c.listSold);

        if (getData.r) {
            this.setState({
                listTable: getData.c.listTable,
                listChart: getData.c.listChart,
                listSold: getData.c.listSold
            })

        }






    }

    colorSwitch = (label) => {


        // console.log('label :', label);

        let u = new Utils();

        let arr = u.colorObject();

        // console.log('arr :', arr);

        let filterArr = arr.filter(a => a.serverLabel === label)

        // console.log('filterArr :', filterArr);

        if (filterArr.length > 0) {
            return filterArr



        } else {
            return [{ color: 'gray', label: this.dictionary.financiarContabil.nuSePoateCalcula }]
        }


    }

    showDetailsIndicator = (ind) => {
        // console.log('ind :', ind);

        this.setState({
            listClassifExpl: ind.ClassificationsExplain,
            strCriteriul: ind.Criteriul,
            isOpenExplanation: true
        })
    }

    buttonSelected = (id) =>{

      
            this.setState({buttonSelectat:id})
            
        
    
    }


    render() {
        return (
            <div>
                       
                       <BackToTop
    
    />

    
                {/* <Grid className='container' style={{ position: 'relative' }} container>

                    {this.state.topButtons.map((b, idx) => {
                        return (
                            <Grid key={idx} style={{ width: 'fit-content', marginTop: 10 }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
          
                                <TopButtons
                                    b={b}
                                    buttonSelected={this.buttonSelected}
                                    buttonSelectat={this.state.buttonSelectat}
                                />





                            </Grid>
                        )

                    })}
                    </Grid> */}

 <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />


                <Divider className="pm-divider" />
                <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>

                        <ExplicatieIndicatori
                            open={this.state.isOpenExplanation}
                            dialogClose={() => { this.setState({ isOpenExplanation: false }) }}
                            title={this.state.strCriteriul}
                            clsExpl={this.state.listClassifExpl}
                        />

              

                        {this.state.buttonSelectat === 'indicatori' && 
                        <div style={{ width: '90%', margin: 'auto' }}>

                            {this.state.listTable.map((tH, idx) => {
                                if (tH.nume !== 'PotentialFinanciar') {


                                    return (
                                        <div key={idx}>
                                            <h2 className='pm-title'>{tH.nume}</h2>

                                            <Table className='pm-indicatori-table'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            {this.dictionary.financiarContabil.criteriul}
                                                        </TableCell>
                                                        <TableCell>
                                                            {this.dictionary.financiarContabil.valoare}
                                                        </TableCell>
                                                        <TableCell>
                                                            {this.dictionary.financiarContabil.clasificare}
                                                        </TableCell>
                                                        <TableCell>
                                                            S1
                                    </TableCell>
                                                        <TableCell>
                                                            S2
                                    </TableCell>
                                                        <TableCell>
                                                            S3
                                    </TableCell>
                                                        <TableCell>
                                                            S4
                                    </TableCell>
                                                        <TableCell>
                                                            Ki
                                    </TableCell>

                                                    </TableRow>
                                                </TableHead>


                                                {tH.nume !== 'PotentialFinanciar' && tH.val.map((tb, idxb) => {


                                                    return (

                                                        <TableBody key={idxb}>
                                                            <TableRow style={{}}>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.Criteriul}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {new Utils().removeSpaces(tb.Valoarea)}
                                                                </TableCell>
                                                                <TableCell onClick={() => { this.showDetailsIndicator(tb) }} style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    <div style={{
                                                                        width: 20,
                                                                        height: 20,
                                                                        cursor: 'help',
                                                                        backgroundColor: this.colorSwitch(tb.ColorClassification)[0].color,
                                                                        borderRadius: '50%'
                                                                    }}>

                                                                    </div>

                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.S1}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.S2}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.S3}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.S4}
                                                                </TableCell>
                                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                                    {tb.Ki}
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow style={{ height: 30 }}>
                                                                <TableCell style={{ paddingTop: 0, fontWeight: 300 }} colSpan={8}>
                                                                    <span>* </span>{tb.DataExplain}
                                                                </TableCell>
                                                            </TableRow>

                                                        </TableBody>
                                                    )
                                                })}


                                            </Table>
                                        </div>
                                    )
                                }
                            })}


                            {this.state.listTable.map((f, idx) => {
                                if (f.nume === 'PotentialFinanciar') {
                                    return (
                                        <Grid key={idx} container>
                                            {f.val.map((fv, idxv) => {
                                                return (
                                                    <Grid style={{ border: '1px solid black' }} key={idxv} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                                        <h3>{`${fv.val.Criteriul}: ${fv.val.Valoarea}`}</h3>
                                                    </Grid>
                                                )
                                            })}

                                        </Grid>
                                    )
                                }
                            })}

                            {
                                this.state.listSold !== null &&
                            

                            <Grid style={{ marginBottom: 50 }} container>


                                <Grid style={{ border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                    <h3> {this.dictionary.financiarContabil.solduriClienti}</h3>
                                    <p><b>{this.dictionary.financiarContabil.debit}: </b> {this.state.listSold.ClientiDebit.Debit} lei</p>
                                    <p><b>{this.dictionary.financiarContabil.credit}:</b>  {this.state.listSold.ClientiCredit.Credit} lei</p>
                                </Grid>

                                <Grid style={{ border: '1px solid black' }} item xs={12} sm={12} md={6} lg={6} xl={6} >
                                    <h3> {this.dictionary.financiarContabil.solduriFurnizori}</h3>
                                    <p><b>{this.dictionary.financiarContabil.debit}: </b>{this.state.listSold.FurnizoriDebit.Debit} lei</p>
                                    <p><b>{this.dictionary.financiarContabil.credit}:</b> {this.state.listSold.FurnizoriCredit.Credit} lei</p>
                                </Grid>



                            </Grid>

                            }



                            {this.state.listChart.map((lC, idx) => {
                                return (
                                    <div key={idx}>


                                        <Grid container >


                                            {lC.val.map((lV, idxv) => {
                                                return (


                                                    Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) > 0 &&



                                                    <Grid className='pm-indicatori-table' key={idxv} style={{ margin: 'auto', marginBottom: 30, position: 'relative' }} item xs={12} sm={12} md={10} lg={10} xl={10} >
                                                        <h2 className='pm-title'>{lC.nume}</h2>
                                                        {/* <ColumnChart
                                    key={idxv}
                                charTitle={lV.Criteriul}
                                chartData={[
                                    ['Nume','valoare', ''],
                                    ['Anul Anterior', 0, Number(lV.ChartDataOldValue)],
                                    ['Anul Curent', Number(lV.ChartDataNewValue),0],
                                ]}
                                /> */}
                                                        <div style={{ position: 'absolute', right: 5, top: 5 }}>
                                                            <span className='pm-title' style={{ fontSize: 20 }}>Clasificare: </span>
                                                            <div
                                                                onClick={() => { this.showDetailsIndicator(lV) }}
                                                                style={{
                                                                    display: 'inline-block',
                                                                    verticalAlign: 'middle',
                                                                    cursor: 'help',
                                                                    width: 85,
                                                                    height: 85,
                                                                    backgroundColor: this.colorSwitch(lV.ColorClassification)[0].color,
                                                                    borderRadius: '50%'
                                                                }}>
                                                                <span className='pm-title' style={{ lineHeight: '80px', color: 'white', fontSize: 16 }}>{this.colorSwitch(lV.ColorClassification)[0].label}</span>
                                                            </div>
                                                        </div>


                                                        {/* <BarCharts3DFinanciar
                                                            //selectEl={this.getDetaliiRaspuns}
                                                            //iSelectat={i}
                                                            // typeOfView={this.state.tipSubiecti}
                                                            titlu={lV.Criteriul}
                                                            content={[

                                                                {
                                                                    label: this.dictionary.financiarContabil.anulAnterior,
                                                                    suma: lV.ChartDataType !== 'values' ? Number(lV.ChartDataOldValue) : (Number(lV.ChartDataOldValue) < Number(lV.ChartDataNewValue) ? (Number(lV.ChartDataOldValue) * 100 / Number(lV.ChartDataNewValue)) : '100'),
                                                                    value: lV.ChartDataOldValue,
                                                                    classC: Number(lV.ChartDataOldValue) < Number(lV.ChartDataNewValue) ? 3 : 2
                                                                },
                                                                {
                                                                    label: this.dictionary.financiarContabil.anulCurent,
                                                                    suma: lV.ChartDataType !== 'values' ? Number(lV.ChartDataNewValue) : (Number(lV.ChartDataOldValue) > Number(lV.ChartDataNewValue) ? (Number(lV.ChartDataNewValue) * 100 / Number(lV.ChartDataOldValue)) : '100'),
                                                                    value: lV.ChartDataNewValue,
                                                                    classC: Number(lV.ChartDataOldValue) < Number(lV.ChartDataNewValue) ? 2 : 3
                                                                }


                                                            ]}

                                                            procente={
                                                                lV.ChartDataType !== 'values' ?
                                                                    <ul className="graph-marker-container">
                                                                        <li style={{ bottom: '10%' }}><span className='graph-ruler-text'>10%</span></li>
                                                                        <li style={{ bottom: '20%' }}><span className='graph-ruler-text'>20%</span></li>
                                                                        <li style={{ bottom: '30%' }}><span className='graph-ruler-text'>30%</span></li>
                                                                        <li style={{ bottom: '40%' }}><span className='graph-ruler-text'>40%</span></li>
                                                                        <li style={{ bottom: '50%' }}><span className='graph-ruler-text'>50%</span></li>
                                                                        <li style={{ bottom: '60%' }}><span className='graph-ruler-text'>60%</span></li>
                                                                        <li style={{ bottom: '70%' }}><span className='graph-ruler-text'>70%</span></li>
                                                                        <li style={{ bottom: '80%' }}><span className='graph-ruler-text'>80%</span></li>
                                                                        <li style={{ bottom: '90%' }}><span className='graph-ruler-text'>90%</span></li>
                                                                        <li style={{ bottom: '100%' }}><span className='graph-ruler-text'>100%</span></li>
                                                                    </ul>

                                                                    : <ul className="graph-marker-container">
                                                                        <li style={{ bottom: '10%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 90) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '20%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 80) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '30%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 70) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '40%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 60) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '50%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 50) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '60%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 40) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '70%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 30) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '80%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 20) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '90%' }}><span className='graph-ruler-text'>{(Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) - ((Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue)) * 10) / 100)).toFixed(0)}</span></li>
                                                                        <li style={{ bottom: '100%' }}><span className='graph-ruler-text'>{Math.max(Number(lV.ChartDataOldValue), Number(lV.ChartDataNewValue))}</span></li>
                                                                    </ul>

                                                            }

                                                        /> */}



                                                        {/* <BarChart 
                                    titlu={lV.Criteriul}
                                    varianteRaspuns={['Anul Anterior','Anul Curent']}
                                    dataGraph={
                                        [
                                            {label: '',
                                                    backgroundColor: Number(lV.ChartDataOldValue) <  Number(lV.ChartDataNewValue)? 'red' : '#18c518',
                                                    borderColor:Number(lV.ChartDataOldValue) <  Number(lV.ChartDataNewValue)? 'red' : '#18c518',
                                                    borderWidth: 1,
                                                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                    hoverBorderColor: 'rgba(255,99,132,1)',
                                                    data: [Number(lV.ChartDataOldValue),0],
                                            },
                                            {label: '',
                                                    backgroundColor: Number(lV.ChartDataOldValue) >  Number(lV.ChartDataNewValue)? 'red' : '#18c518',
                                                    borderColor: Number(lV.ChartDataOldValue) >  Number(lV.ChartDataNewValue)? 'red' : '#18c518',
                                                    borderWidth: 1,
                                                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                                                    hoverBorderColor: 'rgba(255,99,132,1)',
                                                    data: [0,Number(lV.ChartDataNewValue)],
                                            }
                                        ]
                                    }

                                /> */}

                                                    </Grid>

                                                )

                                            })}


                                        </Grid>

                                    </div>
                                )
                            })}



                        </div>

                        }

                        {this.state.buttonSelectat === '' && 
                            <div>

                                <AnalizaDeVanzariSiClienti />

                            </div>
                        }

                        {this.state.buttonSelectat === '' && 
                        <div style={{ marginTop: 10 }}>
                            <FisaClientului />
                        </div>
                        }

                        {this.state.buttonSelectat === '' &&
                    
                        <div style={{ marginTop: 10 }}>

                            <FacturiNeincasate />
                        </div>
                    }

                    {this.state.buttonSelectat === '' && 
                
                        <div style={{ marginTop: 10 }}>
                            <ComparatieRealizatPlanificat />
                        </div>
                }

                {this.state.buttonSelectat === '' && 
            
                        <div style={{ marginTop: 10 }}>

                            <ClientiNoiLunar />
                        </div>
            }
            {this.state.buttonSelectat === '' && 
            <div>
                        <div style={{ marginTop: 10 }}>
                            <TrendDePastrareClientiTrimestru />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <ClientiStari />

                        </div>
            </div>
            }
            {this.state.buttonSelectat === '' &&
                    <div style={{ marginTop: 10 }}>
                    <SegmentareClientiInFunctieDeCaracteristici />
                </div>
             }
                        

            
         </div>
                    );
                   }
            }
